import { useState } from "react";
import "@/App.css";
import { translations } from "@/i18n/translations";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { Security } from "@/components/landing/Security";
import { Everything } from "@/components/landing/Everything";
import { Waitlist } from "@/components/landing/Waitlist";
import { Footer } from "@/components/landing/Footer";

function App() {
  const [lang, setLang] = useState("es");
  const t = translations[lang];

  return (
    <div className="min-h-screen bg-[#050505] text-white font-body">
      <Header t={t} lang={lang} setLang={setLang} />
      <Hero t={t} lang={lang} />
      <Features t={t} />
      <Security t={t} />
      <Everything t={t} />
      <Waitlist t={t} lang={lang} />
      <Footer t={t} lang={lang} />
    </div>
  );
}

export default App;
